var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"ma-0 label",attrs:{"dense":"","hide-details":"","input-value":_vm.checked,"id":_vm.id,"data-testid":_vm.testId,"label":_vm.name},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }